import {useState, useRef} from 'react';
import {Modal} from 'react-bootstrap';
import {SwitchTransition, CSSTransition} from 'react-transition-group';

import {StyledModal} from '../../common/shared/modal.styled';
import BankDataForm from './BankDataForm';
import {StyledContainer} from './autoBankCharge.styled';
import Signature from './Signature';
import {AutoChargePdf} from './AutoChargePdf';

export function AutoBankChargePopup({show, onHide, onSuccess, address = {}, apartmentNumber, tenantDetails = {}, currency}) {
    const nodeRef = useRef(null);
    const [formData, setFormData] = useState({});
    const [signature, setSignature] = useState('');
    const [renderSignature, setRenderSignature] = useState(false);
    const [showPdf, setShowPdf] = useState(false);

    /**
     * @param {{
     *   bankCode: { value: string };
     *   branchNumber: string;
     *   accountNumber: string;
     *   date: string;
     *   ownerId: string;
     * }} values
     * */
    const saveBankData = (evt, values) => {
        evt.preventDefault();
        setFormData(values);
        setRenderSignature(true);
    }

    const createPdf = async signature => {
        setSignature(signature);
        setShowPdf(true);
    }

    /**
     * @param {{ imageBase64: string, imageName: string }} data
     * */
    function handleAutoChargePdfSuccess(data) {
        setRenderSignature(false);
        onSuccess({
            ...data,
            ...formData,
        });
    }

    return (
        <StyledModal
            centered
            dialogClassName="auto-bank-charge"
            show={show}
            onHide={onHide}
        >
            <span
                className={'modal-close'}
                onClick={onHide}
            >
                &#215;
            </span>
            <Modal.Body>
                <StyledContainer>
                    <SwitchTransition mode={'out-in'}>
                        <CSSTransition
                            key={renderSignature ? 'signature' : 'form'}
                            timeout={300}
                            classNames="fade"
                            nodeRef={nodeRef}
                        >
                            <div className="transition-container" ref={nodeRef}>
                                {
                                    renderSignature ? (
                                        <Signature
                                            onContinue={createPdf}
                                            onBack={() => setRenderSignature(false)}
                                        />
                                    ) : (
                                        <BankDataForm
                                            className="transition-item"
                                            onContinue={saveBankData}
                                            address={address}
                                            tenantDetails={tenantDetails}
                                            apartmentNumber={apartmentNumber}
                                            currency={currency}
                                        />
                                    )
                                }
                            </div>
                        </CSSTransition>
                    </SwitchTransition>
                    {showPdf && (
                        <AutoChargePdf
                            signature={signature}
                            address={address}
                            tenantDetails={tenantDetails}
                            apartmentNumber={apartmentNumber}
                            formData={formData}
                            hidePdf={() => setShowPdf(false)}
                            onSuccess={handleAutoChargePdfSuccess}
                        />
                    )}

                </StyledContainer>
            </Modal.Body>
        </StyledModal>
    )
}
